const baseGetActivityAttributeOptions = (fields: string[]) => `
  query ActivityAttributeOptions($id: Int!, $searchString: String) {
    activityAttributeOption(activityAttributeId: $id, searchString: $searchString) {
      value: id
      label: optionName
      ${fields.join('\n')}
    }
  }
`;

export const getActivityAttributeOptions = baseGetActivityAttributeOptions([]);

export const getActivityAttributesWithFields = (fields: string[]) => baseGetActivityAttributeOptions(fields);

export interface GetActivityAttributeOptionsType {
  activityAttributeOption: {
    value: number;
    label: string;
    isDefault?: boolean;
  }[];
}
